(() => {
  function init(root = document) {
    const menu = root.querySelector('.menu');
    const nav = root.querySelector('#navigation');
    if (menu && nav && !menu.dataset.ready) {
      menu.dataset.ready = 'true';
      const close = () => { nav.classList.remove('open'); menu.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-label', document.body.dataset.menuOpen); };
      menu.addEventListener('click', () => { const open = nav.classList.toggle('open'); menu.setAttribute('aria-expanded', String(open)); menu.setAttribute('aria-label', open ? document.body.dataset.menuClose : document.body.dataset.menuOpen); });
      nav.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
      nav.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); menu.focus(); } });
    }
    root.querySelectorAll('.filters').forEach(filters => {
      if (filters.dataset.ready) return;
      filters.dataset.ready = 'true';
      const scope = filters.closest('.work');
      filters.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        filters.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        scope.querySelectorAll('.project').forEach(p => { p.hidden = button.dataset.filter !== 'all' && p.dataset.category !== button.dataset.filter; });
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const card = e.target.closest('.project');
    if (card) {
      const work = card.closest('.work');
      const all = work.querySelector('[data-filter="all"]');
      if (all) all.click();
    }
  });
  const status = document.querySelector('[data-form-status]');
  if (status) { status.focus(); status.scrollIntoView({ block: 'center', behavior: 'instant' }); }
})();
// Prefill the real Shopify enquiry form from a quantity offer.
document.addEventListener('click', event => {
  const offer = event.target.closest('[data-cap-quantity]');
  if (!offer) return;
  const quantity = document.getElementById(offer.dataset.capForm === 'caps' ? 'CapsContactQuantity' : 'ContactQuantity');
  const service = document.getElementById(offer.dataset.capForm === 'caps' ? 'CapsContactService' : 'ContactService');
  if (quantity) quantity.value = offer.dataset.capQuantity;
  if (service && service.options.length > 2) service.selectedIndex = 2;
});

// Open the brochure for direct links, browser history and returned form errors.
(() => {
  function revealCaps() {
    const panel = document.getElementById('kepsar');
    if (!panel) return;
    const target = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
    if ((target && (target === panel || panel.contains(target))) || panel.querySelector('[data-form-status]')) {
      panel.open = true;
      if (target) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
      const status = panel.querySelector('[data-form-status]');
      if (status) { status.focus(); status.scrollIntoView({block:'center'}); }
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-open-caps]');
    if (link) { const panel = document.getElementById('kepsar'); if (panel) panel.open = true; }
  });
  window.addEventListener('hashchange', revealCaps);
  document.addEventListener('shopify:section:load', revealCaps);
  revealCaps();
})();
